export const StatusSkeleton = () => {
  return (
    <div data-testid="status-skeleton" className="flex animate-pulse space-x-4">
      <div className={`inline-flex max-w-full items-center space-x-2 rounded-full border border-[#eeeff1] p-1 text-sm font-medium`}>
        <div className="h-4 w-4 rounded-full bg-gray-300" />
        <div className="h-2 w-14 rounded-full bg-gray-300" />
      </div>
    </div>
  );
};
